// External libraries
import { Component } from "react";

// Preact Signals
import { effect } from "@preact/signals-react";

// Kendo React components
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Error, Hint } from "@progress/kendo-react-labels";
import { Ripple } from "@progress/kendo-react-ripple";

// Internal components
import { If } from "../../Common/UI/IfComponent";
import { TooltipPopupIcon } from "../../Common/UI/TooltipPopupIcon";

// Utilities
import { validators } from "../../Form/validators";

// Signals
import { branchDataset, userData } from "../../Common/Store/CommonSignals";
import { disabledSections, readOnlyEntry } from "../../Entry/Manage/EditEntrySignals";

export class BusinessUnitField extends Component {
  constructor({
    field,
    handleFieldChange,
    sectionIndex,
    fieldIndex,
    labelVisible,
    eventIndex,
    value,
    isPrintPreview,
  }) {
    super();
    const { fieldName, properties } = field;
    this.state = {
      value: value || userData.value?.officeLocation,
      options: branchDataset.value?.values.map((value) => value.value),
      valid: true,
      disabled: false,
    };
    this.fieldName = typeof eventIndex === "number" ? `${fieldName}_${eventIndex}` : fieldName;
    this.labelVisible = labelVisible;
    this.label = properties?.Label || `${fieldName}:`;
    this.fieldInformation = properties?.FieldInformation;
    this.isReadOnly = properties?.IsReadOnly;
    this.sectionIndex = sectionIndex;
    this.fieldIndex = fieldIndex;
    this.eventIndex = eventIndex;
    this.handleFieldChange = handleFieldChange;
    this.isPrintPreview = isPrintPreview;
    this.disposeDisabledSectionsEffect = () => {};
  }

  componentDidMount() {
    this.disposeDisabledSectionsEffect = effect(() => {
      const isSectionDisabled = disabledSections.value[this.sectionName];
      if (this.state.disabled !== isSectionDisabled) {
        this.setState({ disabled: isSectionDisabled });
      }
    });
  }

  componentWillUnmount() {
    this.disposeDisabledSectionsEffect();
  }

  shouldComponentUpdate(_, nextState) {
    return this.state.value !== nextState.value || this.state.disabled !== nextState.disabled;
  }

  //#region custom functions
  validate(value) {
    return this.isRequired ? validators.required(value) : true;
  }

  onChange(e) {
    this.setState({
      validationMessage: this.validate(e.value),
      value: e.value,
    });
    this.handleFieldChange({
      e,
      sectionIndex: this.sectionIndex,
      fieldIndex: this.fieldIndex,
      fieldType: this.fieldType,
      eventIndex: this.eventIndex,
    });
  }

  onBlur() {
    this.setState((prevState) => ({
      validationMessage: this.validate(prevState.value),
    }));
  }
  //#endregion custom functions

  render() {
    return (
      <Ripple>
        <div
          ref={this.inputRef}
          className="k-d-flex k-flex-col"
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <DropDownList
              data-testid={this.fieldName}
              id={this.fieldName}
              name={this.fieldName}
              label={this.labelVisible ? this.label : null}
              data={this.state.options}
              defaultValue={this.state.value || userData.value?.officeLocation}
              onChange={(e) => this.onChange(e)}
              onBlur={() => this.onBlur()}
              disabled={
                this.isPrintPreview || this.isReadOnly || this.state.disabled || readOnlyEntry.value
              }
            />
            <If
              condition={
                this.fieldInformation !== undefined &&
                this.fieldInformation !== "" &&
                this.fieldInformation !== "<p></p>"
              }
            >
              <TooltipPopupIcon content={this.fieldInformation} />
            </If>
          </div>
          <If condition={this.hint}>
            <Hint>{this.hint}</Hint>
          </If>
          <If condition={!this.state.valid && this.state.touched}>
            <Error>{this.validationMessage}</Error>
          </If>
        </div>
      </Ripple>
    );
  }
}
